import React, { useState } from "react";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import { useNavigate } from "react-router-dom";
import "./caroussel.css";
import "./carousselMedia.css"

const GenericGallery = ({ 
  galleryData, 
  galleryType, 
  baseRoute 
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = galleryData.length;
  const currentData = galleryData[currentSlide];
  const navigate = useNavigate();

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const handleViewImages = () => {
    navigate(`${baseRoute}/${currentData.id}`);
  };

  return (
    <div className="caroussel-page">
      {/* Fondo */}
      <div
        className="background-container-caroussel"
        style={{ backgroundImage: `url(${currentData.backgroundImage})` }}
      ></div>
      <div className="overlay-dark"></div>
      <Navbar />

      {/* Contenedor principal del carrusel */}
      <div className="caroussel-container">
        {/* Contenido (textos + rectángulo con imagen) */}
        <div className="caroussel-content">
          <div className="text-content">
            <p className="caroussel-subtitle">{currentData.subtitle}</p>
            <h1 className="caroussel-title">{currentData.title}</h1>
            <p className="caroussel-description">
              {currentData.description}
            </p>
            <button onClick={handleViewImages} className="ver-imagenes-btn">
              <span>Ver imágenes</span>
            </button>
          </div>

          <div className="btn-right">
            <div
              className="image-preview"
              style={{ backgroundImage: `url(${currentData.backgroundImage})` }}
            >
              <div className="preview-overlay">
                <span className="image-counter">
                  {currentSlide + 1} / {totalSlides}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Controles del carrusel */}
        <div className="caroussel-controls">
          <div className="navigation-buttons">
            <button className="nav-btn" onClick={prevSlide}>&lt;</button>
            <button className="nav-btn" onClick={nextSlide}>&gt;</button>
          </div>
          <div className="caroussel-indicator">
            <div className="indicator-container">
              {galleryData.map((_, index) => (
                <div
                  key={index}
                  className={`indicator-dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GenericGallery;